import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { CopyToClipboardButton } from '../CopyToClipboadButton';
export const NumericCell = observer(function NumericCell({ value, }) {
    return (_jsxs("div", { children: [value, _jsx(CopyToClipboardButton, { text: value.toString() })] }));
});
